import { render } from "./BasementSetting.vue?vue&type=template&id=38fb01d6&scoped=true"
import script from "./BasementSetting.vue?vue&type=script&lang=js"
export * from "./BasementSetting.vue?vue&type=script&lang=js"

import "./BasementSetting.vue?vue&type=style&index=0&id=38fb01d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fb01d6"]])

export default __exports__